import WowzaVideoPlayer from './WowzaVideoPlayer';

export default WowzaVideoPlayer;
export * from './types';
export { WowzaVideoPlayer };
